import { createGlobalStyle } from 'styled-components';
import BasierCircle from '../fonts/basiercircle-regular-webfont.woff2';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
                "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans",
                "Helvetica Neue", sans-serif !important;
  }

  @font-face {
    font-family: BasierCircle;
    src: url(${BasierCircle});
  }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    line-height: 1.5em;
  }

  input, select {
    font-family: inherit;
    font-size: inherit;
  }
`;
